import { useEffect } from "react";

/**
 * Custom hook to set the document title
 * @param {string} title - The page title to set
 * @param {string} [suffix=" | Artistiggo Studio"] - Optional suffix to append
 */
export const usePageTitle = (title, suffix = "") => {
  useEffect(() => {
    document.title = title + suffix;

    // Optional: Cleanup to restore default title when unmounting
    return () => {
      document.title = "Artistiggo Studio";
    };
  }, [title, suffix]);
};
